import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
  Icon,
  IconButton,
  Text,
} from "@prismicio/editor-ui"

interface RepeatableLinkFieldActionsProps {
  onDelete: () => void
  onMoveUp: () => void
  onMoveDown: () => void
  isDeleteEnabled: boolean
  isMoveUpEnabled: boolean
  isMoveDownEnabled: boolean
}

export function RepeatableLinkFieldActions(
  props: RepeatableLinkFieldActionsProps,
) {
  const {
    onDelete,
    isDeleteEnabled,
    onMoveUp,
    onMoveDown,
    isMoveUpEnabled,
    isMoveDownEnabled,
  } = props

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <IconButton
          hiddenLabel="Link actions"
          icon="moreVert"
          size="small"
          variant="solid"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>
          <Text variant="small" color="grey11">
            Item options
          </Text>
        </DropdownMenuLabel>
        <DropdownMenuItem
          onSelect={onMoveUp}
          startIcon={<Icon name="arrowUpward" />}
          disabled={!isMoveUpEnabled}
        >
          Move up
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={onMoveDown}
          startIcon={<Icon name="arrowDownward" />}
          disabled={!isMoveDownEnabled}
        >
          Move down
        </DropdownMenuItem>
        <DropdownMenuItem
          color="tomato"
          onSelect={onDelete}
          startIcon={<Icon name="delete" color="tomato9" />}
          disabled={!isDeleteEnabled}
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
